import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { Map, GpxViewer } from './components';
import './App.css';

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Map/>}/>
                    <Route path="/gpx/:trace_gpx" element={<GpxViewer/>}/>
                </Routes>
            </div>
        </BrowserRouter>
    );
};

export default App;